export default __webpack_public_path__ + "d413f29377fff01432fb25ce1502a3ac.svg";